import React from 'react';
import { IToolButtonProps } from '../../../../interfaces';
import { ToolButton } from '../../../../components';
import { hideAlert, showAlert } from '../../../../components/alert/Alert';
import { AlertTypeEnum, StateTopicEnum } from '../../../../enums';
import { securityService } from '../../../../_global/services';
import { UserPermissions } from '../../../../definitions';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { useSubscription } from '../../../../hooks';
import { updateSubscription } from '../../service/dataService';
import { ISubscriptionTiers } from '../../types';

const SaveButton = ({ config, item }: IToolButtonProps) => {
  const { id: moduleId } = config;
  const { _id } = item;

  const [invalid, setInvalid] = React.useState(true);
  const [userEditItem, setUserEditItem] =
    React.useState<ISubscriptionTiers>(item);

  useSubscription(StateTopicEnum.IsValid, (valid: boolean) =>
    setInvalid(!valid)
  );

  useSubscription(
    StateTopicEnum.EditSubscription,
    (editItem: ISubscriptionTiers) => setUserEditItem(editItem)
  );

  const handleConfirm = async () => {
    await updateSubscription({
      _id,
      hotel_search_limit: userEditItem.hotelSearchLimit,
      flight_search_limit: userEditItem.flightSearchLimit,
      tier: userEditItem.tier
    });
    hideAlert();
    setInvalid(true);
  };

  const handleClick = async () => {
    showAlert({
      content: 'You are about to save your changes. Are you sure?',
      options: {
        actions: [
          {
            text: 'Yes',
            onClick: handleConfirm,
            primary: true
          },
          { text: 'No', onClick: hideAlert }
        ],
        type: AlertTypeEnum.Warning
      }
    });
    return true;
  };

  return (
    <ToolButton
      text='Save'
      icon={faSave}
      path={`/${moduleId}/${_id}`}
      primary
      raised
      onClick={handleClick}
      invalid={
        invalid ||
        !securityService.checkRoleAccess(UserPermissions.editSubscription)
      }
    />
  );
};

export default SaveButton;
